import React from 'react';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import { CheckIcon } from '@heroicons/react/24/outline';
import { Tag } from '@teetsh/app/src/components/Tag';
import Button from '@teetsh/app/src/components/Buttons/Button';
import Card from '@teetsh/app/src/components/Card';
import { useCreatePaymentLink } from '@teetsh/app/src/queries/payments/useCreatePaymentLink';

function BenefitItem({ children }: { children: React.ReactNode }) {
  return (
    <div tw="flex gap-2 items-start">
      <CheckIcon tw="w-5 h-5 text-positive-quiet shrink-0 mt-0.5" />
      <p tw="text-sm font-semibold text-neutral-moderate">{children}</p>
    </div>
  );
}

export function PackPurchaseCard() {
  const { t } = useTranslation(['userSettings']);
  const { mutateAsync, isPending } = useCreatePaymentLink();

  const handlePurchase = () => {
    mutateAsync({ packAICredits8: 1 });
  };

  return (
    <Card tw="p-4! md:p-6! border-neutral-quiet">
      <div tw="flex flex-col gap-6">
        <div tw="flex flex-col gap-4">
          <div tw="inline">
            <Tag tw="inline-flex" size="sm" color="limoncello-supershy">
              {t('userSettings:aiUsage.packIA')}
            </Tag>
          </div>

          <h1 tw="display">{t('userSettings:aiUsage.packPricing8')}</h1>

          <div tw="flex flex-col gap-2">
            <BenefitItem>
              <span tw="font-semibold text-neutral-moderate">
                {t('userSettings:aiUsage.packBenefit1Title')}
              </span>
              <span tw="font-normal text-neutral-moderate">
                {t('userSettings:aiUsage.packBenefit1Description')}
              </span>
            </BenefitItem>

            <BenefitItem>{t('userSettings:aiUsage.packBenefit2')}</BenefitItem>

            <BenefitItem>{t('userSettings:aiUsage.packBenefit3')}</BenefitItem>
          </div>
        </div>

        <Button
          onClick={handlePurchase}
          intent="primary"
          fill
          loading={isPending}
        >
          {t('userSettings:aiUsage.choosePack')}
        </Button>
      </div>
    </Card>
  );
}
